module.exports = __webpack_public_path__ + "img/covid pattern.f42f5479.jpg";